import { types } from 'mobx-state-tree';

const ServiceOptionType = {
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  SELECT: 'SELECT'
};

export default ServiceOptionType;

export const ServiceOptionTypeType = types.enumeration(
  'ServiceOptionType',
  Object.values(ServiceOptionType)
);
